import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pin-threshold",
  "use": "icon-pin-threshold-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pin-threshold\">\n<path d=\"M9.03027 0.719727L7.96973 1.78027L8.7915 2.60205L4.14209 6.33154L3.03027 5.21973L1.96973 6.28027L4.82031 9.13086L0.25 13.6997V14.75H1.30029L5.86914 10.1797L8.71973 13.0303L9.78027 11.9697L8.73291 10.9224L12.4111 6.22168L13.2197 7.03027L14.2803 5.96973L9.03027 0.719727ZM9.84912 3.67725L11.3345 5.1626L7.73242 9.76953L5.29346 7.33057L9.84912 3.67725Z\" fill=\"CurrentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol